const ShowIfNone = ({ children }) => children

export default ShowIfNone
